import React from 'react';
import {Button, Input, Modal} from "../common";
import {ALERT_TYPES, BUTTON_TYPES, INPUT_PLACEHOLDERS} from "../../types";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useMutation} from "react-query";
import {useAlert} from "../common/Alert";
import {phoneRegex} from "../../utils/regex";

interface ISchema {
  [key: string]: string;
  fio: string;
  phone: string;
  email: string;
}

const AppointmentModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { setAlert } = useAlert();

  const sendRequest = useMutation(["sendRequest"], {
    onMutate: (data: { fio: string; phone: string; email: string }) => {},
    onSuccess: () => {
      setAlert('Заявка успешно отправлена!', ALERT_TYPES.SUCCESS);
      onClose();
    },
    onError: (e: any) => {
      const errorText: string = `${Object.values(e.response.data).flat(2)?.[0]}`;
      setAlert(errorText, ALERT_TYPES.ERROR);
    }
  })

  const validationSchema: Yup.Schema<ISchema> = Yup.object().shape({
    fio: Yup.string().required('Поле не может быть пустым'),
    phone: Yup.string().required('Поле не может быть пустым')?.matches(phoneRegex, 'Невалидный номер телефона'),
    email: Yup.string()?.email('Невалидный email').required('Email не может быть пустым'),
  });

  const submitForm = async (values: any) => {
    const { fio, phone, email } = values;
    await sendRequest.mutate({
      fio, phone, email
    })

  }

  const formik = useFormik({
    initialValues: {
      fio: '',
      phone: '',
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: submitForm
  });

  const {
    errors, touched
  } = formik;

  const handleSubmit = () => formik.handleSubmit();

  return (
    <Modal open={open} onClose={onClose}>
      <div className="max-w-[485px] flex flex-col items-center">
        <h1 className="text-white font-bold text-[32px] leading-[39px] mb-4 text-center">
          Оставьте заявку и мы свяжемся с вами
        </h1>

        <div className="w-full">
          <p className="mb-1 text-white text-[14px] leading-[24px] font-medium">ФИО</p>
          <Input
            id="fio"
            name="fio"
            onChange={formik.handleChange}
            error={touched?.fio ? errors?.fio : false}
            placeholder="ФИО"
            className="py-[7px] w-full bg-black border-white/20 border-solid border text-white"
          />
        </div>

        <div className="w-full mt-3">
          <p className="mb-1 text-white text-[14px] leading-[24px] font-medium">Номер телефона</p>
          <Input
            id="phone"
            name="phone"
            onChange={formik.handleChange}
            error={touched?.phone ? errors?.phone : false}
            placeholder={INPUT_PLACEHOLDERS.PHONE}
            className="py-[7px] w-full bg-black border-white/20 border-solid border text-white"
          />
        </div>

        <div className="w-full mt-3 mb-10">
          <p className="mb-1 text-white text-[14px] leading-[24px] font-medium">Адрес электронной почты</p>
          <Input
            id="email"
            name="email"
            onChange={formik.handleChange}
            error={touched?.email ? errors?.email : false}
            type="email"
            placeholder="example@mail.com"
            className="py-[7px] w-full bg-black border-white/20 border-solid border text-white"
          />
        </div>

        <Button title="Отправить" onClick={handleSubmit} type={BUTTON_TYPES.SECONDARY} className="px-12" />
      </div>
    </Modal>
  )
};

export default AppointmentModal;
